import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ReportService } from '@app/modules/report/services';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CanUploadInvoiceGuard implements CanActivate {
  constructor(private readonly reportService: ReportService, private router: Router) { }
  canAccess = false;
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.reportService.hasAdminAccess().pipe(
      map((response: any) => {
        if (response?.adminAccess?.canUpload) {
          return true;
        } else {
          this.router.navigate(['/dashboard']);
        }
      }),
      catchError((error) => {
        console.log('error:', error);
        this.router.navigate(['/dashboard']);
        return of(false);
      })
    )
  }

}
